<ion-app>
  <app-warning-notice *ngIf="(networkStatus.online$ | async) === false" class="global-network-warning" text="NO_INTERNET_CONNECTION"
    variant="error"></app-warning-notice>
  <ion-router-outlet [animated]="false"></ion-router-outlet>
</ion-app>
